import { Div, Collection, Table } from "@tblabs/truffle";
import { Human } from "../../../../Models/Human";


export class PeoplePrinter extends Div
{
    constructor(people: Collection<Human>)
    {
        super();

        this.Append(
            ...people.Map(x =>
                new Div().Text(`${x.Type.value}\n${x.ExperienceIcon} ${x.Name.value}\n☎️ ${x.Phone.value}\n📧 ${x.Email.value}\n📌 ${x.Address.value}\n🗒️ ${x.Description.value || "(brak notatki)"}\n🏦 ${x.BankAccountNumber.value || "(brak numeru konta)"}\n🧭 ${x.Origin.value || "(brak źródła)"}`)
                    .Style(`display: inline-block; font-size: 1rem; text-align: left; padding: 1rem; margin: 1rem; border-bottom: 1px solid #f3f4f6; background-color: #f9fafb; border-radius: 0.75rem;`)
            )
        );
    }
}
